// 融资项目--申请
import request from '@/utils/request.js'
import qs from 'qs'

// 融资项目--列表 + 搜索功能
export const financingList = (page, phone) => {
  return request({
    method: 'get',
    url: `/zzzx/finance/${page}/${phone || ''}`
  })
}

// 融资项目--删除
export const ModifyState = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/modifystate/${id}`
  })
}

// 融资项目--详情
export const findOrderDetail = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/findorderdetail/${id}`
  })
}

// 融资需求--列表
export const financingNeedList = (type, page, phone, cancelToken) => {
  return request({
    method: 'get',
    url: `/zzzx/getfinanceneed/${type}/${page}/${phone || ''}`,
    cancelToken
  })
}
// 融资需求--修改
export const financingNeedUpdate = (type, id) => {
  return request({
    method: 'post',
    url: `/zzzx/revisefinanceneed/${type}/${id}`
  })
}
